import { render, staticRenderFns } from "./pc-location.vue?vue&type=template&id=52b26f3b&scoped=true&"
import script from "./pc-location.vue?vue&type=script&lang=ts&"
export * from "./pc-location.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b26f3b",
  null
  
)

export default component.exports